// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import Menu from "./Menu";

// const Layout = ({ children, defaultOpen = true, footer = null }) => {
//   const [isMenuOpen, setIsMenuOpen] = useState(() => {
//     const savedState = localStorage.getItem("sidebarState");
//     return savedState !== null ? JSON.parse(savedState) : defaultOpen;
//   });

//   useEffect(() => {
//     localStorage.setItem("sidebarState", JSON.stringify(isMenuOpen));
//   }, [isMenuOpen]);

//   const toggleMenu = () => setIsMenuOpen((prev) => !prev);
//   const location = useLocation();
  
//   const isProjectChatRoute = location.pathname.startsWith("/Project-chat");
//   const isKnowledgeBaseChat = location.pathname === "/rfp-knowledgeBase/chat";
//   const isChatRoute = isKnowledgeBaseChat || isProjectChatRoute;

//   return (
//     <div className="flex h-screen w-full bg-[#f8f9fa] overflow-hidden">
      
//       {!isProjectChatRoute && (
//         <Menu isOpen={isMenuOpen} toggleMenu={toggleMenu} />
//       )}
      
//       {/* 
//         Modified: The wrapper now handles overall overflow-hidden, 
//         separating the scrollable children area from the fixed footer 
//       */}
//       <div className="flex-1 flex flex-col h-full overflow-hidden relative">
        
//         {/* Scrollable Main Content Area */}
//         <div className="flex-1 overflow-x-hidden overflow-y-auto">
//           {children}
//         </div>
        
//         {/* Fixed Pagination Footer (Renders only if the `footer` prop is provided) */}
//         {footer && (
//           <div className="w-full bg-white border-t border-gray-200 p-4 shrink-0 z-10">
//             {footer}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Layout;
import React, { useState, useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Sidebar from "./Sidebar"; // Redesigned sidebar (replaces ./Menu)
import OnboardingHost from "../onboarding/OnboardingHost";

const Layout = ({ defaultOpen = true }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(() => {
    const savedState = localStorage.getItem("sidebarState");
    return savedState !== null ? JSON.parse(savedState) : defaultOpen;
  });
  const [workspaceKey, setWorkspaceKey] = useState(0);

  useEffect(() => {
    const handler = () => setWorkspaceKey((k) => k + 1);
    window.addEventListener("workspace-changed", handler);
    return () => window.removeEventListener("workspace-changed", handler);
  }, []);

  // The product tour spotlights nav labels, which only exist while the nav is open.
  useEffect(() => {
    const open = () => setIsMenuOpen(true);
    window.addEventListener("onboarding-expand-nav", open);
    return () => window.removeEventListener("onboarding-expand-nav", open);
  }, []);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);
  const location = useLocation();

  // The nav state is the user's own choice on every route, the copilot
  // included: saved whenever it changes, never overridden on arrival.
  useEffect(() => {
    localStorage.setItem("sidebarState", JSON.stringify(isMenuOpen));
  }, [isMenuOpen]);

  const isProjectChatRoute = location.pathname.startsWith("/Project-chat");
  const isKnowledgeBaseChat = location.pathname === "/rfp-knowledgeBase/chat";
  
  // Note: Removed the footer prop, footers should now be rendered directly inside the page components

  return (
    <div className="flex h-screen w-full bg-[#f8f9fa] overflow-hidden">
      {!isProjectChatRoute && (
        <Sidebar isOpen={isMenuOpen} toggleMenu={toggleMenu} />
      )}
      
      <div className="flex-1 flex flex-col h-full overflow-hidden relative">
        <div className="flex-1 overflow-x-hidden overflow-y-auto">
          {/* 
            Outlet automatically injects the current page's component here.
            We pass context so pages like Contract can use isMenuOpen if needed via useOutletContext()
          */}
          <Outlet key={workspaceKey} context={{ isMenuOpen }} />
        </div>
      </div>
      <OnboardingHost />
    </div>
  );
};

export default Layout;